<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <BookingTemplateForm
          ref="bookingTemplateForm"
          :bookingTemplate="bookingTemplate"
          @onSubmit="updateTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="validateForm"
        :loading="isEditingBookingTemplate"
      >
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_BOOKING_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-booking-templates";
import { copyState } from "@/utils/helpers";
import {
  EDIT_ORGANISATION_BOOKING_TEMPLATE,
  FETCH_ORGANISATION_BOOKING_TEMPLATES
} from "@/store/modules/organisations/organisation-booking-templates/actions";
import BookingTemplateForm from "@/views/settings/components/role-templates/components/BookingTemplateForm";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_BOOKING_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    bookingTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    BookingTemplateForm
  },
  computed: {
    ...mapState(copyState(["isEditingBookingTemplate"])),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Role Template"
      };
    }
  },
  methods: {
    ...mapActions({
      editBookingTemplate: EDIT_ORGANISATION_BOOKING_TEMPLATE,
      fetchBookingTemplates: FETCH_ORGANISATION_BOOKING_TEMPLATES
    }),
    validateForm() {
      this.$refs.bookingTemplateForm.validateForm();
    },
    async updateTemplate(bookingTemplateData) {
      await this.editBookingTemplate(bookingTemplateData);
      this.fetchBookingTemplates();
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
